/**
 * Capitalizes the first letter of each word in a string
 * @param str - The input string to capitalize
 * @returns A string with each word's first letter capitalized
 * @example
 * capitalizeWords('HELLO WORLD') // returns 'Hello World'
 * capitalizeWords('hello world') // returns 'Hello World'
 */
export function capitalizeWords(str: string): string {
  if (!str) return str;

  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
